import React from 'react';
import PropTypes from 'prop-types';
import HrbTranslate from '../../../components/language/HrbTranslate';
import { FilingStatus } from '../services/FilingStatus';
import EmdashText from '../../../components/library/common/EmdashText';

const ReturnStatusLabel = ({ dashboardStatus, isRefile, isMailedIn, refileCount, returnId, showReturnId }) => {

    let statusKey = ''
    let returnIdKey = 'ReturnInfo.Labels.ReturnId'
    if (isRefile && !dashboardStatus.includes('REFILE')&&!dashboardStatus.includes('PROREFILE')&&!dashboardStatus.includes('PROREFILEMRQ')&&!dashboardStatus.includes('REFILECRA')&&!dashboardStatus.includes('REFILEMRQ')) {
        statusKey = 'ReturnInfo.Labels.NETFILE'
    } else if (isRefile && (dashboardStatus.includes('REFILE')||(dashboardStatus.includes('PROREFILE')||dashboardStatus.includes('PROREFILEMRQ')||dashboardStatus.includes('REFILECRA')||dashboardStatus.includes('REFILEMRQ')) )) {
        statusKey = 'ReturnInfo.Labels.ReFile'
    } else if (isRefile && !dashboardStatus) {
        statusKey = 'ReturnInfo.Labels.ReFile'
    } else if (isMailedIn || dashboardStatus === FilingStatus.PAPERFILED) {
        statusKey = 'ReturnInfo.FilingStatus.MAILEDIN'
    } else if (dashboardStatus === 'EFILE') {
        statusKey = 'ReturnInfo.Labels.EFILED'
    } else if (dashboardStatus === 'EFILEMRQ') {
        statusKey = 'ReturnInfo.Labels.EFILED'
    } else if (dashboardStatus === 'EFILET1135') {
        statusKey = 'ReturnInfo.Labels.EFILED'
    } else if (dashboardStatus === 'T1135') {
        statusKey = 'ReturnInfo.Labels.NETFILE'
    } else {
        statusKey = 'ReturnInfo.Labels.NETFILE'
    }

    return (
    <div className='pr-3'>
        {(showReturnId && returnId !== 0) && (dashboardStatus !== 'NOT_FILED' && dashboardStatus !== 'REFILE_STARTED' && dashboardStatus !== 'IN_PROGRESS') &&

            <p className='p1 return-status-title is-uppercase'>< HrbTranslate text={statusKey} className='is-uppercase' /> {isRefile ? ' #' + refileCount : ''} | <HrbTranslate text={returnIdKey} className='is-uppercase' />{returnId !== 0 ? returnId : <EmdashText />}</p>
        }
        {(showReturnId && returnId !== 0) && (dashboardStatus === 'NOT_FILED' || dashboardStatus === 'REFILE_STARTED' || dashboardStatus === 'IN_PROGRESS') &&
            <p className='p1 return-status-title is-uppercase'>< HrbTranslate text={statusKey} className='is-uppercase' /> {isRefile ? ' #' + refileCount : ''} | <HrbTranslate text={returnIdKey} className='is-uppercase' /><EmdashText /></p>
        }
        {(!showReturnId && refileCount) &&
            <p className='p1 return-status-title is-uppercase'>< HrbTranslate text={statusKey} className='is-uppercase' /> {isRefile ? ' #' + refileCount : ''}</p>
        }
        {(!showReturnId) &&
            <p className='p1 return-status-title is-uppercase'>< HrbTranslate text={statusKey} className='is-uppercase' /></p>
        }
    </div>
    )
}

ReturnStatusLabel.propTypes = {
    dashboardStatus: PropTypes.string,
    isRefile: PropTypes.bool
}

export default ReturnStatusLabel;
